import { isEmpty } from 'ramda'

type Options = {
  hasDishes: boolean
  hasComplexes: boolean
  currentCategoryId?: string
  dishesByCategory: { [catId: string]: unknown }
  onChangeCategory: (categoryId: string) => void
}

export const categoryVerification = ({
  hasDishes,
  hasComplexes,
  currentCategoryId,
  dishesByCategory,
  onChangeCategory,
}: Options) => {
  const hasCategories = !isEmpty(dishesByCategory)

  // Вариант когда категория задана
  if (currentCategoryId) {
    // категория не 'комплекты'
    if (currentCategoryId !== 'kits') {
      if (hasCategories && hasDishes) {
        // есть блюда, категории и в ней существует текущая
        if (dishesByCategory[currentCategoryId]) {
          return // ничего не меняется
        }
        // текущей категории больше нет, берем первую попавшуюся
        onChangeCategory(Object.keys(dishesByCategory)[0])
        return
      }
      // нет блюд и категорий, но есть комплекты
      if (hasComplexes) {
        onChangeCategory('kits') // редирект в комплекты
        return
      }
    }

    // категория 'комплекты'
    if (currentCategoryId === 'kits' && hasComplexes) {
      return // не меняется, так как комплекты существуют
    }

    // ничего не получилось с текущей категорией
    onChangeCategory('') // возврат в корень
    return
  }

  // Вароиант когда категория не задана
  if (!currentCategoryId) {
    // есть блюда и категории
    if (hasCategories && hasDishes) {
      // редиректим в первую попавшуюся категорию
      onChangeCategory(Object.keys(dishesByCategory)[0])
      return
    }

    // нет болюд, но есть комплекты
    if (hasComplexes) {
      onChangeCategory('kits') // редирект в комплекты
      return
    }
  }
}
